import Cookies from "js-cookie";
import axios from "../../../../../axios";

export const GetUsers = async (userUID) => {
    return axios.get("/api/Admin/users");
};

export const ActivateUser = async (userUID) => {
    return axios.post("/api/Admin/users/activate", { userUID });
};

export const DeactivateUser = async (userUID) => {
    return axios.post("/api/Admin/users/deactivate", { userUID });
};